import { Link } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from './ui/button';

interface NoAccessPageProps {
  appSlug: string;
}

export function NoAccessPage({ appSlug }: NoAccessPageProps) {
  const { t } = useTranslation('shared');
  const appName = appSlug.toUpperCase();

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center">
      <div className="text-center max-w-md px-4">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-red-100 p-4">
            <ShieldX className="h-12 w-12 text-red-600" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">{t('access.deniedTitle')}</h1>

        <p className="text-gray-600 mb-6">
          <Trans
            i18nKey="access.deniedBody"
            ns="shared"
            values={{ appName }}
            components={{ app: <span className="font-semibold" /> }}
          />
        </p>

        <Button asChild>
          <Link to="/">{t('access.goToDashboard')}</Link>
        </Button>
      </div>
    </div>
  );
}
